import { BEIGE_500 } from 'constants/styling/theme'

/**
 * The catalogue's card hover from the design: the card tints and the tint spreads 12px past its edge,
 * so the card itself keeps its size and position. Only for a real pointer; a tap would leave it stuck.
 */
export const PF_CARD_HOVER_SX = {
  borderRadius: '0.8rem',
  transition: 'background-color 120ms ease, box-shadow 120ms ease',
  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': { backgroundColor: BEIGE_500, boxShadow: `0 0 0 1.2rem ${BEIGE_500}` },
  },
} as const
